import { render, staticRenderFns } from "./ModalCriarCliente.vue?vue&type=template&id=9e8e43fa&"
import script from "./ModalCriarCliente.vue?vue&type=script&lang=js&"
export * from "./ModalCriarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports